import React from 'react';
import styled from '@emotion/styled';
import sizes from 'style/sizes';
import { mq } from 'style/variables';
import Img from 'components/atoms/img';
import { css } from '@emotion/core';
import { Video } from 'components/atoms/video';

type MediaGridProps = {
  imgs: Array<MediasObject>;
  spGrid?: boolean;
  noSpPadding?: boolean;
};
type MediasObject = {
  path: string;
  alt: string;
  column: number;
};

type MediaWrapperProps = {
  column: number;
  spGrid?: boolean;
};

const Container = styled.div<MediaGridProps>`
  margin-bottom: ${sizes.margin[180]};
  ${mq.onlypc} {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  ${mq.onlysp} {
    margin-bottom: ${sizes.margin[100]};
    ${props => props.noSpPadding && `padding: 0;`}
    ${props =>
      props.spGrid &&
      css`
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      `}
  }
`;

const MediaWrapperContainer = styled.div<MediaWrapperProps>`
  margin-bottom: 16px;
  ${mq.onlypc} {
    width: calc(((100% - 16px * ${props => props.column - 1}) / ${props => props.column}));
  }
  ${mq.onlysp} {
    margin-bottom: 1px;
    ${props =>
      props.spGrid &&
      css`
        width: calc(((100% - 1px * ${props.column - 1}) / ${props.column}));
      `}
  }
`;

const MediaWrapper: React.FC<MediaWrapperProps> = props => {
  return <MediaWrapperContainer {...props}>{props.children}</MediaWrapperContainer>;
};

export const MediaGrid: React.FC<MediaGridProps> = props => {
  const imgLength = props.imgs.length;

  return (
    <Container {...props}>
      {props.imgs.map((item, idx) => (
        <MediaWrapper column={item.column} key={idx} spGrid={props.spGrid}>
          {item.path.includes('.mp4') || item.path.includes('.mov') ? (
            <Video
              url={item.path || ''}
              aspectRation={
                (imgLength === 3 && idx === 0) || (imgLength === 6 && (idx === 0 || idx === 1))
                  ? '655 / 1160'
                  : '431 / 572'
              }
            />
          ) : (
            <Img filename={item.path} alt={item.alt} />
          )}
        </MediaWrapper>
      ))}
    </Container>
  );
};
